import { createAction, props } from '@ngrx/store';
import {ScreeningCriteriaCreateDTO, ScreeningCriteriaDTO} from '../../dto/screening-criteria';

export const loadScreeningCriterias = createAction(
  '[ScreeningCriteria] Load ScreeningCriterias',
  props<{ projectId: number }>()
);
export const loadScreeningCriteriasSuccess = createAction(
  '[ScreeningCriteria] Load ScreeningCriterias Success',
  props<{ projectId: number; criteria: ScreeningCriteriaDTO[] }>()
);
export const loadScreeningCriteriasFailure = createAction(
  '[ScreeningCriteria] Load ScreeningCriterias Failure',
  props<{ projectId: number; error: any }>()
);

export const createScreeningCriteria = createAction(
  '[ScreeningCriteria] Create ScreeningCriteria',
  props<{ projectId: number; criteria: ScreeningCriteriaCreateDTO }>()
);
export const createScreeningCriteriaSuccess = createAction(
  '[ScreeningCriteria] Create ScreeningCriteria Success',
  props<{ projectId: number; criteria: ScreeningCriteriaDTO }>()
);
export const createScreeningCriteriaFailure = createAction(
  '[ScreeningCriteria] Create ScreeningCriteria Failure',
  props<{ projectId: number; error: any }>()
);

export const deleteScreeningCriteria = createAction(
  '[ScreeningCriteria] Delete ScreeningCriteria',
  props<{ projectId: number; id: number }>()
);
export const deleteScreeningCriteriaSuccess = createAction(
  '[ScreeningCriteria] Delete ScreeningCriteria Success',
  props<{ projectId: number; id: number }>()
);
export const deleteScreeningCriteriaFailure = createAction(
  '[ScreeningCriteria] Delete ScreeningCriteria Failure',
  props<{ projectId: number; error: any }>()
);

export const retrieveScreeningCriteria = createAction(
  '[ScreeningCriteria] Retrieve ScreeningCriteria',
  props<{ projectId: number; id: number }>()
);
export const retrieveScreeningCriteriaSuccess = createAction(
  '[ScreeningCriteria] Retrieve ScreeningCriteria Success',
  props<{ projectId: number; criteria: ScreeningCriteriaDTO }>()
);
export const retrieveScreeningCriteriaFailure = createAction(
  '[ScreeningCriteria] Retrieve ScreeningCriteria Failure',
  props<{ projectId: number; error: any }>()
);

export const updateScreeningCriteria = createAction(
  '[ScreeningCriteria] Update ScreeningCriteria',
  props<{ projectId: number; id: number; criteria: ScreeningCriteriaDTO }>()
);
export const updateScreeningCriteriaSuccess = createAction(
  '[ScreeningCriteria] Update ScreeningCriteria Success',
  props<{ projectId: number; criteria: ScreeningCriteriaDTO }>()
);
export const updateScreeningCriteriaFailure = createAction(
  '[ScreeningCriteria] Update ScreeningCriteria Failure',
  props<{ projectId: number; error: any }>()
);
